/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IButtonStyles, IMessageBarStyles, IPanelStyles, ITextStyles } from "@fluentui/react";

export const panelHeaderStyles: ITextStyles = {
  root: {
    fontWeight: "600",
    fontSize: "32px",
    lineHeight: "40px",
    flexGrow: 1,
    margin: "24px",
  },
};

export const buttonStyles: IButtonStyles = {
  root: {
    marginRight: 8,
    width: "120px",
    height: "32px",
  },
};

//add margin top to the message bar
export const messageBarStyles: IMessageBarStyles = {
  root: {
    backgroundColor: "white",
    color: "#33333",
    marginBottom: "1rem",
  },
  icon: {
    color: "#ff0000",
  },
};

export const panelContentStyles: Partial<IPanelStyles> = {
  root: {
    height: "100%",
  },
  content: {
    height: "100%",
  },
};
